module.exports = __webpack_public_path__ + "img/tmgaz-logo.12698269.png";